import { render, staticRenderFns } from "./CollegeCertificateDataManage.vue?vue&type=template&id=fe14054c&scoped=true"
import script from "./CollegeCertificateDataManage.vue?vue&type=script&lang=js"
export * from "./CollegeCertificateDataManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe14054c",
  null
  
)

export default component.exports